var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math, addedSugar, barcode, bottomlink, carbs, cholesterol, decimalPlacesForNutrition, disclaimer, fiber, footer, header, ingredientList, itemName, model, monoFat, parseFloat, polyFat, protein, roundLoDash, satFat, shortenFootnoteSection, showDV, showServingUnitQuantity, showServingWeightGrams, showServingsPerContainer, singleServing, sodium, sugar, sugarAlcohol, text, totalFat, transFat, unitServingWeight, valueServingPerContainer, valueServingSizeUnit, valueServingUnitQuantity, valueServingWeightGrams, variedServings, width) {pug_mixins["notApplicableFn"] = pug_interp = function(txt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cfont class=\"notApplicable\" aria-hidden=\"true\"\u003E" + (pug.escape(null == (pug_interp = txt) ? "" : pug_interp)) + "\u003C\u002Ffont\u003E";
};
pug_mixins["qtyHtml"] = pug_interp = function(roundLoDash, arg1, arg2){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan itemprop=\"servingSize\"\u003E" + (pug.escape(null == (pug_interp = roundLoDash(arg1, arg2)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
};




pug_mixins["pctHtml"] = pug_interp = function(model, idx){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"pull-right\"\u003E\u003Cdiv class=\"nutrient\"\u003E%\u003C\u002Fdiv\u003E\u003Cdiv class=\"nutrient\"\u003E";
var num = model.allowFDARounding ? model[model[idx].roundFn2](model[idx].value) : model[idx].value
var den = model[idx].dv == 0 ? 1 : model[idx].dv * model.roundLoDash(parseFloat(model['calories'].dv) / 2000, 2)
pug_html = pug_html + (pug.escape(null == (pug_interp = roundLoDash(num / den * 100, model.decimalPlacesForDailyValues)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["pctHtmlHorizontal"] = pug_interp = function(model, idx){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"tabularright\"\u003E\u003Cspan class=\"nutrientcontentvalue nutrient\"\u003E";
var num = model.allowFDARounding ? model[model[idx].roundFn2](model[idx].value) : model[idx].value
var den = model[idx].dv == 0 ? 1 : model[idx].dv * model.roundLoDash(parseFloat(model['calories'].dv) / 2000, 2)
pug_html = pug_html + (pug.escape(null == (pug_interp = roundLoDash(num / den * 100, model.decimalPlacesForDailyValues)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"nutrient\"\u003E%\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["attributeHtmlHorizontal"] = pug_interp = function(model, idx, topDivClass, lineclass, topId){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("id", topId, true, true)) + "\u003E\u003Cdiv" + (pug.attr("class", pug.classes([lineclass], [true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes([topDivClass], [true]), false, true)+pug.attr("style", pug.style((idx=='filler' ?'opacity:0':'')), true, true)) + "\u003E";
if (idx == 'filler') {
pug_html = pug_html + "\u003Cspan class=\"longform\"\u003EFiller\u003C\u002Fspan\u003E";
}
else {
if (shortenFootnoteSection && model[idx].abbr) {
pug_html = pug_html + "\u003Cspan class=\"abbreviated\"\u003E" + (null == (pug_interp = model[idx].abbr + '&nbsp;') ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"longform\"\u003E" + (null == (pug_interp = model[idx].text + '&nbsp;') ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"nutrientcontent\"\u003E";
if (model[idx].na) {
pug_mixins["notApplicableFn"](model.text.notApplicable);
}
else
if (model.allowFDARounding) {
pug_html = pug_html + (null == (pug_interp = model[model[idx].roundFn](model[idx].value, model.decimalPlacesForNutrition) + model[idx].unit) ? "" : pug_interp);
}
else {
pug_html = pug_html + (null == (pug_interp = roundLoDash(model[idx].value, model.decimalPlacesForNutrition) + model[idx].unit) ? "" : pug_interp);
}
if (model[idx].text2) {
pug_html = pug_html + (null == (pug_interp = '&nbsp;' + model[idx].text2) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
if (showDV) {
pug_mixins["pctHtmlHorizontal"](model, idx);
}
}
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};









































pug_mixins["vitaminRowHorizontal"] = pug_interp = function(model, idx){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var vits = ['vitaminD', 'calcium', 'iron', 'potassium', 'vitaminA', 'vitaminC', 'vitaminE', 'vitaminK', 'thiamin', 'riboflavin', 'niacin', 'vitaminB6', 'folate', 'vitaminB12', 'pantothenicAcid', 'phosphorus', 'magnesium', 'zinc', 'selenium', 'copper', 'manganese']
var first = true
// iterate vits
;(function(){
  var $$obj = vits;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var idx = $$obj[pug_index0];
if (model[idx].show) {
pug_html = pug_html + (null == (pug_interp = "<span class='inlineVitamin'>") ? "" : pug_interp);
if (!first) {
pug_html = pug_html + (null == (pug_interp = " • ") ? "" : pug_interp);
}
else {
first = false
}
pug_html = pug_html + (pug.escape(null == (pug_interp = model[idx].text + " ") ? "" : pug_interp));
if (model[idx].na) {
pug_mixins["notApplicableFn"].call({
block: function(){
pug_html = pug_html + "     ";
}
}, model.text.notApplicable);
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = roundLoDash((model[idx].value / 100) * model[idx].dv, model.decimalPlacesForDailyValues) + model[idx].unit) ? "" : pug_interp));
}
pug_html = pug_html + ((pug.escape(null == (pug_interp = " " + roundLoDash(model[idx].value, model.decimalPlacesForDailyValues) + '%') ? "" : pug_interp)) + (null == (pug_interp = "</span>") ? "" : pug_interp));
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var idx = $$obj[pug_index0];
if (model[idx].show) {
pug_html = pug_html + (null == (pug_interp = "<span class='inlineVitamin'>") ? "" : pug_interp);
if (!first) {
pug_html = pug_html + (null == (pug_interp = " • ") ? "" : pug_interp);
}
else {
first = false
}
pug_html = pug_html + (pug.escape(null == (pug_interp = model[idx].text + " ") ? "" : pug_interp));
if (model[idx].na) {
pug_mixins["notApplicableFn"].call({
block: function(){
pug_html = pug_html + "     ";
}
}, model.text.notApplicable);
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = roundLoDash((model[idx].value / 100) * model[idx].dv, model.decimalPlacesForDailyValues) + model[idx].unit) ? "" : pug_interp));
}
pug_html = pug_html + ((pug.escape(null == (pug_interp = " " + roundLoDash(model[idx].value, model.decimalPlacesForDailyValues) + '%') ? "" : pug_interp)) + (null == (pug_interp = "</span>") ? "" : pug_interp));
}
    }
  }
}).call(this);

};
pug_html = pug_html + "\u003Cdiv id=\"label-and-claim-div\"\u003E       \u003Cdiv id=\"label-wrapper\"\u003E\u003Cdiv id=\"label\"\u003E   ";
if (header.show) {
pug_html = pug_html + "\u003Cdiv class=\"nf-header nf-title\" tabindex=\"0\"\u003E" + (pug.escape(null == (pug_interp = header.text) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (itemName.show) {
pug_html = pug_html + "\u003Cdiv class=\"nf-itemName nf-title\"\u003E" + (pug.escape(null == (pug_interp = itemName.text) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv id=\"newtabularnutritionfactstable\"\u003E\u003Cdiv id=\"new_tabular_macro_col\"\u003E\u003Cdiv id=\"newtabularheading\"\u003E" + (pug.escape(null == (pug_interp = text.nutritionFacts) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"hairlineseparator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"servingsize servingsizenewtabular\"\u003E\u003Cdiv class=\"servings-per-container-div\"\u003E";
if (showServingUnitQuantity && valueServingUnitQuantity > 0 && showServingsPerContainer && valueServingPerContainer > 0) {
if (!singleServing) {
if (!variedServings) {
pug_html = pug_html + "\u003Cspan class=\"servings-per-container\"\u003E                 " + (pug.escape(null == (pug_interp = roundLoDash(valueServingPerContainer, decimalPlacesForNutrition) + ' ' + (shortenFootnoteSection ? text.abbrServingsPerContainer : text.servingsPerContainer)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"servings-per-container-varied\"\u003E" + (pug.escape(null == (pug_interp = 'Varied ' + (shortenFootnoteSection ? text.abbrServingsPerContainer : text.servingsPerContainer)) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"servingsizenew-bold\" style=\"font-size: 11px; line-height: 13px;\"\u003E\u003Cdiv style=\"float:left\"\u003E" + (pug.escape(null == (pug_interp = text.servingSize) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv style=\"float:right\"\u003E ";
pug_mixins["qtyHtml"](roundLoDash, valueServingUnitQuantity, decimalPlacesForNutrition);
if (showServingUnitQuantity && valueServingUnitQuantity > 0 && valueServingSizeUnit) {
pug_html = pug_html + (pug.escape(null == (pug_interp = ' ' + valueServingSizeUnit) ? "" : pug_interp));
if (showServingWeightGrams && valueServingWeightGrams > 0) {
pug_html = pug_html + (pug.escape(null == (pug_interp = '(' + roundLoDash(valueServingWeightGrams, decimalPlacesForNutrition) + unitServingWeight + ')') ? "" : pug_interp));
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"thickseparator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nutrient\" id=\"newtabularcalories\" style=\"position:relative;\"\u003E\u003Cdiv style=\"float:left;\"\u003E\u003Cdiv class=\"new-calories-tabular\"\u003ECalories\u003C\u002Fdiv\u003E" + (pug.escape(null == (pug_interp = text.amountPerServing.replace("Amount ", "")) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"calories-tabular\"\u003E" + (pug.escape(null == (pug_interp = roundLoDash(model['calories'].value, model.decimalPlacesForNutrition)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"new_tabular_nutrient_cols\" style=\"width: 427px;\"\u003E\u003Cdiv class=\"new_tabular_nutrient_col\" style=\"width: 210px;\"\u003E\u003Cdiv class=\"label label-amount\" style=\"margin-bottom:-2px;\"\u003EAmount\u002Fserving\u003Cspan class=\"label tabularright\"\u003E" + (pug.escape(null == (pug_interp = shortenFootnoteSection ? text.abbrDailyValues : text.dailyValues) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nutrients_col_1\"\u003E";
var items = 0
if (totalFat.show) {
items += 1
}
if (satFat.show) {
items += 1
}
if (transFat.show) {
items += 1
}
if (polyFat.show) {
items += 1
}
if (monoFat.show) {
items += 1
}
if (cholesterol.show) {
items += 1
}
if (sodium.show) {
items += 1
}
if (carbs.show) {
items += 1
}
if (fiber.show) {
items += 1
}
if (sugar.show) {
items += 1
}
if (addedSugar.show) {
items += 1
}
if (sugarAlcohol.show) {
items += 1
}
if (protein.show) {
items += 1
}
var half = Math.floor(items / 2)
if (totalFat.show && items >= half) {
items--
pug_mixins["attributeHtmlHorizontal"](model, 'totalFat', 'nutrient', 'hairlineseparator', 'totalfatnewtabular');
}
if (satFat.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'satFat', 'nutrientsubgroup', 'hairlineseparator', 'satfatnewtabular');
}
if (transFat.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'transFat', 'nutrientsubgroup', 'hairlineseparator', 'transfatnewtabular');
}
if (polyFat.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'polyFat', 'nutrientsubgroup', 'hairlineseparator', 'polyunsatfatnewtabular');
}
if (monoFat.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'monoFat', 'nutrientsubgroup', 'hairlineseparator', 'monounsatfatnewtabular');
}
if (cholesterol.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'cholesterol', 'nutrient', 'hairlineseparator', 'cholesterolnewtabular');
}
if (sodium.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'sodium', 'nutrient', 'hairlineseparator', 'sodiumnewtabular');
}
if (carbs.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'carbs', 'nutrient', 'hidden', 'totalcarbsnewtabular');
}
if (fiber.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'fiber', 'nutrientsubgroup', 'hairlineseparator', 'fibernewtabular');
}
if (sugar.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'sugar', 'nutrientsubgroup', 'hairlineseparator', 'sugarnewtabular');
}
if (addedSugar.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'addedSugar', 'nutrientsubsubgroup', 'subsubhairlineseparator', 'addedsugarnewtabular');
}
if (sugarAlcohol.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"].call({
block: function(){
pug_html = pug_html + " ";
}
}, model, 'sugarAlcohol', 'nutrientsubgroup', 'hairlineseparator', 'sugaralcoholnewtabular');
}
if (protein.show && items >= half) {
items--              
pug_mixins["attributeHtmlHorizontal"](model, 'protein', 'nutrient', 'hairlineseparator', 'proteinnewtabular');
}
pug_html = pug_html + "\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"new_tabular_nutrient_col\" style=\"width: 210px;\"\u003E\u003Cdiv class=\"label label-amount\" style=\"margin-bottom:-2px;\"\u003EAmount\u002Fserving\u003Cspan class=\"label tabularright\"\u003E" + (pug.escape(null == (pug_interp = shortenFootnoteSection ? text.abbrDailyValues : text.dailyValues) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"nutrients_col_2\"\u003E";
half = Math.floor(half)
items = half * 2
if (totalFat.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'totalFat', 'nutrient', 'hairlineseparator', 'totalfatnewtabular');
}
if (satFat.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'satFat', 'nutrientsubgroup', 'hairlineseparator', 'satfatnewtabular');
}
if (transFat.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'transFat', 'nutrientsubgroup', 'hairlineseparator', 'transfatnewtabular');
}
if (polyFat.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'polyFat', 'nutrientsubgroup', 'hairlineseparator', 'polyunsatfatnewtabular');
}
if (monoFat.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'monoFat', 'nutrientsubgroup', 'hairlineseparator', 'monounsatfatnewtabular');
}
if (cholesterol.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'cholesterol', 'nutrient', 'hairlineseparator', 'cholesterolnewtabular');
}
if (sodium.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'sodium', 'nutrient', 'hairlineseparator', 'sodiumnewtabular');
}
if (carbs.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'carbs', 'nutrient', 'hairlineseperator', 'totalcarbsnewtabular');
}
if (fiber.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'fiber', 'nutrientsubgroup', 'hairlineseparator', 'fibernewtabular');
}
if (sugar.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'sugar', 'nutrientsubgroup', 'hairlineseparator', 'sugarnewtabular');
}
if (addedSugar.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'addedSugar', 'nutrientsubsubgroup', 'subsubhairlineseparator', 'addedsugarnewtabular');
}
if (sugarAlcohol.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"].call({
block: function(){
pug_html = pug_html + " ";
}
}, model, 'sugarAlcohol', 'nutrientsubgroup', 'hairlineseparator', 'sugaralcoholnewtabular');
}
if (protein.show && items-- < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'protein', 'nutrient', 'hairlineseparator', 'proteinnewtabular');
}
if (items < half) {
pug_mixins["attributeHtmlHorizontal"](model, 'filler', 'nutrient invisible', 'hairlineseparator', 'new_filler_col_2');
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"separator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"clear:both;\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"vitaminsectionnewtabular\"\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"vitaminnewtabularrow\"\u003E";
pug_mixins["vitaminRowHorizontal"](model, 0);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"insignificant-nutrients-list-new-tabular\" style=\"display:none;\"\u003E\u003Cdiv class=\"hairlineseparator\"\u003E\u003C\u002Fdiv\u003ENot a significant source of trans fat, added sugars, or vitamin D\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"new_tabular_asterisk_col\"\u003E\u003Cdiv class=\"asterisk\"\u003E*\u003C\u002Fdiv\u003E\u003Cdiv class=\"asterisk_text\" style=\"width:70px;\"\u003E" + (pug.escape(null == (pug_interp = text.percentDaily2018VersionPart1) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv style=\"clear:both\"\u003E\u003C\u002Fdiv\u003E";
if (ingredientList.show) {
pug_html = pug_html + "\u003Cdiv" + (" id=\"recipe-show-ingredient-list\""+pug.attr("style", pug.style('width:'+width+'px;display: block; text-align: left; text-transform: none;'), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = ingredientList.text) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv style=\"clear:both\"\u003E       \u003C\u002Fdiv\u003E";
if (disclaimer.show && disclaimer.text) {
pug_html = pug_html + "\u003Cdiv" + (" id=\"nf-calcDisclaimer\""+pug.attr("style", pug.style('width:'+width+'px'), true, true)) + "\u003E\u003Cspan id=\"nf-calcDisclaimerText\" tabindex=\"0\"\u003E" + (pug.escape(null == (pug_interp = "CONTAINS: " + disclaimer.text) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv style=\"clear:both\"\u003E\u003C\u002Fdiv\u003E";
if (bottomlink.show) {
pug_html = pug_html + "\u003Ca" + (" class=\"nf-homeLinkPrint\""+pug.attr("href", bottomlink.link, true, true)+" target=\"_newSite\"") + "\u003E" + (pug.escape(null == (pug_interp = bottomlink.text) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003Cdiv style=\"display:flex;\"\u003E";
if (footer.show) {
pug_html = pug_html + "\u003Cdiv class=\"nf-customFooter\" tabindex=\"0\" style=\"flex-grow:1.0;\"\u003E" + (null == (pug_interp = footer.text.replace("${arg1}", footer.arg1).replace("${arg2}", footer.arg2)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
if (barcode.show) {
pug_html = pug_html + "\u003Cdiv class=\"nf-barcode\" tabindex=\"0\" style=\"flex-grow:1.0;\"\u003E" + (null == (pug_interp = barcode.text) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"addedSugar" in locals_for_with?locals_for_with.addedSugar:typeof addedSugar!=="undefined"?addedSugar:undefined,"barcode" in locals_for_with?locals_for_with.barcode:typeof barcode!=="undefined"?barcode:undefined,"bottomlink" in locals_for_with?locals_for_with.bottomlink:typeof bottomlink!=="undefined"?bottomlink:undefined,"carbs" in locals_for_with?locals_for_with.carbs:typeof carbs!=="undefined"?carbs:undefined,"cholesterol" in locals_for_with?locals_for_with.cholesterol:typeof cholesterol!=="undefined"?cholesterol:undefined,"decimalPlacesForNutrition" in locals_for_with?locals_for_with.decimalPlacesForNutrition:typeof decimalPlacesForNutrition!=="undefined"?decimalPlacesForNutrition:undefined,"disclaimer" in locals_for_with?locals_for_with.disclaimer:typeof disclaimer!=="undefined"?disclaimer:undefined,"fiber" in locals_for_with?locals_for_with.fiber:typeof fiber!=="undefined"?fiber:undefined,"footer" in locals_for_with?locals_for_with.footer:typeof footer!=="undefined"?footer:undefined,"header" in locals_for_with?locals_for_with.header:typeof header!=="undefined"?header:undefined,"ingredientList" in locals_for_with?locals_for_with.ingredientList:typeof ingredientList!=="undefined"?ingredientList:undefined,"itemName" in locals_for_with?locals_for_with.itemName:typeof itemName!=="undefined"?itemName:undefined,"model" in locals_for_with?locals_for_with.model:typeof model!=="undefined"?model:undefined,"monoFat" in locals_for_with?locals_for_with.monoFat:typeof monoFat!=="undefined"?monoFat:undefined,"parseFloat" in locals_for_with?locals_for_with.parseFloat:typeof parseFloat!=="undefined"?parseFloat:undefined,"polyFat" in locals_for_with?locals_for_with.polyFat:typeof polyFat!=="undefined"?polyFat:undefined,"protein" in locals_for_with?locals_for_with.protein:typeof protein!=="undefined"?protein:undefined,"roundLoDash" in locals_for_with?locals_for_with.roundLoDash:typeof roundLoDash!=="undefined"?roundLoDash:undefined,"satFat" in locals_for_with?locals_for_with.satFat:typeof satFat!=="undefined"?satFat:undefined,"shortenFootnoteSection" in locals_for_with?locals_for_with.shortenFootnoteSection:typeof shortenFootnoteSection!=="undefined"?shortenFootnoteSection:undefined,"showDV" in locals_for_with?locals_for_with.showDV:typeof showDV!=="undefined"?showDV:undefined,"showServingUnitQuantity" in locals_for_with?locals_for_with.showServingUnitQuantity:typeof showServingUnitQuantity!=="undefined"?showServingUnitQuantity:undefined,"showServingWeightGrams" in locals_for_with?locals_for_with.showServingWeightGrams:typeof showServingWeightGrams!=="undefined"?showServingWeightGrams:undefined,"showServingsPerContainer" in locals_for_with?locals_for_with.showServingsPerContainer:typeof showServingsPerContainer!=="undefined"?showServingsPerContainer:undefined,"singleServing" in locals_for_with?locals_for_with.singleServing:typeof singleServing!=="undefined"?singleServing:undefined,"sodium" in locals_for_with?locals_for_with.sodium:typeof sodium!=="undefined"?sodium:undefined,"sugar" in locals_for_with?locals_for_with.sugar:typeof sugar!=="undefined"?sugar:undefined,"sugarAlcohol" in locals_for_with?locals_for_with.sugarAlcohol:typeof sugarAlcohol!=="undefined"?sugarAlcohol:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined,"totalFat" in locals_for_with?locals_for_with.totalFat:typeof totalFat!=="undefined"?totalFat:undefined,"transFat" in locals_for_with?locals_for_with.transFat:typeof transFat!=="undefined"?transFat:undefined,"unitServingWeight" in locals_for_with?locals_for_with.unitServingWeight:typeof unitServingWeight!=="undefined"?unitServingWeight:undefined,"valueServingPerContainer" in locals_for_with?locals_for_with.valueServingPerContainer:typeof valueServingPerContainer!=="undefined"?valueServingPerContainer:undefined,"valueServingSizeUnit" in locals_for_with?locals_for_with.valueServingSizeUnit:typeof valueServingSizeUnit!=="undefined"?valueServingSizeUnit:undefined,"valueServingUnitQuantity" in locals_for_with?locals_for_with.valueServingUnitQuantity:typeof valueServingUnitQuantity!=="undefined"?valueServingUnitQuantity:undefined,"valueServingWeightGrams" in locals_for_with?locals_for_with.valueServingWeightGrams:typeof valueServingWeightGrams!=="undefined"?valueServingWeightGrams:undefined,"variedServings" in locals_for_with?locals_for_with.variedServings:typeof variedServings!=="undefined"?variedServings:undefined,"width" in locals_for_with?locals_for_with.width:typeof width!=="undefined"?width:undefined));;return pug_html;};
module.exports = template;